module.exports = __webpack_public_path__ + "img/nexultra-l-brush-icon.470096f8.svg";